module.exports = __webpack_public_path__ + "img/046.aa7f2b3d.png";